import { SCKpis } from "../../common/generic/generic-sc-domain";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";
import { SCProfileDictionary } from "../../common/salescredit/salescredit-profile-dictionary";
import { ISCUser } from "../../common/salescredit/salescredit-role-types";
import { ISalesCreditFicIndicator } from "./types";

export function MapGenericData(
  userRole: ISCUser,
  rawdata: IGenericAggregateResponse
): ISalesCreditFicIndicator {
  if (rawdata.aggregates) {
    const row = rawdata.aggregates[0];
    const pd = new SCProfileDictionary();
    const returnData: ISalesCreditFicIndicator = {
      CVA_Ytd:
        row.indicatorKpiValues[pd.GetKpi(userRole.Profile, SCKpis.SC_CVA_YTD)],
      CVA_Ytd1:
        row.indicatorKpiValues[
          pd.GetKpi(userRole.Profile, SCKpis.SC_CVA_YTD_1)
        ],
      F2Y_Ytd:
        row.indicatorKpiValues[pd.GetKpi(userRole.Profile, SCKpis.SC_F2Y_YTD)],
      F2Y_Ytd1:
        row.indicatorKpiValues[
          pd.GetKpi(userRole.Profile, SCKpis.SC_F2Y_YTD_1)
        ],
      MarkUp_Ytd:
        row.indicatorKpiValues[
          pd.GetKpi(userRole.Profile, SCKpis.SC_MARKUP_YTD)
        ],
      MarkUp_Ytd1:
        row.indicatorKpiValues[
          pd.GetKpi(userRole.Profile, SCKpis.SC_MARKUP_YTD_1)
        ],
    };
    return returnData;
  } else {
    return {
      CVA_Ytd: 0,
      CVA_Ytd1: 0,
      F2Y_Ytd: 0,
      F2Y_Ytd1: 0,
      MarkUp_Ytd: 0,
      MarkUp_Ytd1: 0,
    };
  }
}

export function GetKpiDetails(userRole: ISCUser): string[] {
  const pd = new SCProfileDictionary();
  return [
    pd.GetKpi(userRole.Profile, SCKpis.SC_CVA_YTD),
    pd.GetKpi(userRole.Profile, SCKpis.SC_CVA_YTD_1),
    pd.GetKpi(userRole.Profile, SCKpis.SC_F2Y_YTD),
    pd.GetKpi(userRole.Profile, SCKpis.SC_F2Y_YTD_1),
    pd.GetKpi(userRole.Profile, SCKpis.SC_MARKUP_YTD),
    pd.GetKpi(userRole.Profile, SCKpis.SC_MARKUP_YTD_1),
  ];
}
